'use client';

import type { DateTimeConfig, ReceiptSettings } from '@/lib/templates/schema';
import { SectionDivider } from './SectionDivider';

interface DateTimeSectionProps {
  config: DateTimeConfig;
  settings: ReceiptSettings;
}

export function DateTimeSection({ config, settings }: DateTimeSectionProps) {
  const alignmentClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  }[config.alignment];
  const isNarrow = settings.spacing === 'narrow';

  return (
    <div className={`receipt-section ${isNarrow ? 'py-0.5' : 'py-2'} ${alignmentClass}`}>
      <div
        style={{
          fontSize: settings.fontSize,
          fontFamily: settings.font,
          whiteSpace: 'pre',  // Preserve spaces exactly as entered
        }}
      >
        {config.dateTime}
      </div>

      {/* Divider */}
      {config.showDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} />
      )}
    </div>
  );
}



